import { render, staticRenderFns } from "./DirectMatchDenyPopup.vue?vue&type=template&id=98502a82&scoped=true"
import script from "./DirectMatchDenyPopup.vue?vue&type=script&lang=js"
export * from "./DirectMatchDenyPopup.vue?vue&type=script&lang=js"
import style0 from "./DirectMatchDenyPopup.vue?vue&type=style&index=0&id=98502a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98502a82",
  null
  
)

export default component.exports